import { Controller } from "@hotwired/stimulus"
import { csrfFetch } from "../lib/csrf_fetch"

// Sends a request on trigger (e.g. change->turbo-request#submit) and renders
// the turbo-stream response. Drives checkboxes, selects, and links whose
// endpoints respond with Turbo Streams.
export default class extends Controller {
  static values = {
    url: String,
    method: { type: String, default: "post" },
    params: Object
  }

  submit(event) {
    event?.preventDefault()

    const params = { ...(this.paramsValue || {}) }

    // Include the triggering form control's current value (e.g. the chosen
    // option of a permission-level select) unless an explicit param already
    // covers it.
    const control = event?.target
    if (control?.name && !(control.name in params)) {
      params[control.name] = control.type === "checkbox" ? control.checked : control.value
    }

    csrfFetch(this.urlValue, {
      method: this.methodValue.toUpperCase(),
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify(params)
    })
      .then(r => r.text())
      .then(html => window.Turbo.renderStreamMessage(html))
  }
}
